<template>
  <div class="c-menu__language">
    <a
      href="#"
      class="c-menu__link"
      slot="trigger"
      :tabindex="menuOpened ? '0' : '-1'"
      aria-haspopup="true"
      :aria-expanded="`${showDropdown}`"
      @click.prevent="toggleDropdown">
      <LanguageIcon class="c-menu__language-svg"/>
      <span class="c-menu__title">{{ $t('LANGUAGE') }}
        <span class="c-menu__locale">{{ getCurrentAppLocaleName }}</span>
      </span>
    </a>
    <div class="c-menu__language-menu" v-show="showDropdown">
      <h3 class="c-menu__language-header">{{ $t('CHOOSE_LANGUAGE') }}</h3>
      <ul class="c-menu__language-select">
        <li class="c-menu__language-option" v-bind:key="key" v-for="(lang, key) in languages"
        :class="(lang.UI_LANG === selectedLocale.text) ? 'selected' : ''" @click.prevent="selectNewLocale(key)">
          <button
            class="c-menu__langauge-text"
            @click.prevent="selectNewLocale(key)"
            :tabindex="menuOpened ? '0' : '-1'"
            :aria-selected="(lang.UI_LANG === selectedLocale.text) ? 'true' : 'false'">
            {{ lang.UI_LANG }}
          </button>
        </li>
      </ul>
      <button class="c-menu__language-btn" @click.prevent="confirmNewLocale(); showDropdown = false" :tabindex="menuOpened ? '0' : '-1'">
        {{ $t('CHANGE_LANGUAGE') }}
      </button>
    </div>
  </div>
</template>
<script>
import { mapActions  } from 'vuex'
import {UserDB} from '@/services/db'
import store from '@/store'
import i18n from '@/i18n/index'

import LanguageIcon from '@/assets/svg/LanguageIcon'

let db = new UserDB()


export default {
  name: 'LanguageDropdown',

  components: {
    'LanguageIcon' : LanguageIcon
  },

  data() {
    return {
      selectedLocale: String,
      languages: Array,
      showDropdown: false
    }
  },

  props: {
    menuOpened: Boolean
  },

  computed: {
    getCurrentAppLocaleName() {
      return i18n.messages[store.state.userSettings.locale].UI_LANG
    }
  },

  methods: {
    selectNewLocale(newLocale) {
      this.selectedLocale = { code: newLocale, text: i18n.messages[newLocale].UI_LANG }
    },

    confirmNewLocale() {
      this.setLocale(this.selectedLocale.code)
      i18n.locale = this.selectedLocale.code
    },

    toggleDropdown() {
      this.showDropdown = !this.showDropdown
    },

    ...mapActions({
      setLocale: 'userSettings/setLocale'
    })
  },

  async mounted() {
    const locale =
      (await db.getLocale('locale')) || store.state.userSettings.locale || i18n.locale
    this.setLocale(locale)

    //update Vuex
    this.toggledMenu = false
    this.languages = i18n.messages
    this.selectedLocale = { code: locale, text: i18n.messages[locale].UI_LANG }
  }
}
</script>
<style lang="scss">
@import '@/assets/scss/_vars.scss';
@import '@/assets/scss/_mixin.scss';

.c-menu__language-svg {
  vertical-align: middle;
}
.c-menu__wrapper .c-menu__title {
  color: $white;
  font-weight: 700;
  font-family: 'Work Sans', sans-serif;  margin-left: 10px;
  vertical-align: middle;
}
.c-menu__wrapper .c-menu__locale {
  line-height: 38px;
  font-weight: 300;
  color: $white;
  text-align: right;
  letter-spacing: -.4px;
  position: absolute;
  right: 40px;
}
.c-menu__language-menu {
  display: block;
  text-align: center;
}
.c-menu__language-header {
  color: $white;
  font-size: 16px;
  font-weight: 700;
}
.c-menu__language-option {
  color: $white;
  font-size: 18px;
  font-weight: 300;
  cursor: pointer;
  position: relative;
  padding: 0 40px;
  &:hover {
    background-color: $lighter-dark-blue;
  }
}
.c-menu__langauge-text {
  @include btnReset();
  padding: 0.2rem;
  @include a11yOutline();
}
.c-menu__language-option.selected:after {
  content: '';
  position: absolute;
  right: 40px;
  top: 5px;
  width: 9px;
  height: 14px;
  border: solid $white;
  border-width:0 3px 3px 0;
  transform: rotate(45deg);
}
.c-menu__language-btn {
  @include btn();
  font-size: 0.9em;
  border: 0;
  width: calc(100% - 80px);
  background: $orange;
  color: $white;
  text-transform: uppercase;
  margin: 1em auto 0;
  &:hover {
    background: $orange-hover;
  }
  @include a11yOutline();
}
</style>
